<ng-container *transloco="let t; read: 'acc-select-input'">
  @if (label()) {
    <span class="label font-normal-semibold" [id]="uid">
      <span>
        {{ label() }}
        @if (requirementLabel()) {
          <span class="font-xxs-semibold">
            {{ t(requirementLabel()) }}
          </span>
        }
      </span>
    </span>
  }

  @if (hint()) {
    <div class="hint font-s-regular">
      {{ hint() }}
    </div>
  }

  <div
    #trigger="cdkOverlayOrigin"
    #selectButtonElement
    cdkOverlayOrigin
    tabindex="0"
    role="combobox"
    class="trigger font-normal-regular"
    aria-haspopup="listbox"
    [attr.aria-labelledby]="uid"
    [attr.aria-expanded]="isOpen"
    [attr.aria-controls]="isOpen ? uid + '-listbox' : null"
    [attr.aria-activedescendant]="isOpen ? activeDescendant : null"
    [ngClass]="size()"
    [class.has-error]="formControlRef()?.invalid && formControlRef()?.touched"
    [attr.data-cy]="
      dataCy() || (label() ? 'select-' + label().split(' ').join('-').toLowerCase() : null)
    "
    (keydown)="keyHandler($event)"
    (click)="onButtonClick()">
    <div class="select-input">
      @if (optionSelected?.name | syncOrAsync) {
        <accredible-icon [icon]="optionSelected[optionIconKey()] | syncOrAsync" />
      }

      <span class="select-input-value" [class.placeholder]="!optionSelected">
        {{ (optionSelected?.name | syncOrAsync) || placeholder() }}
      </span>
    </div>

    <div class="icons-container">
      @if (optionSelected && optionSelected[optionImgKey()]) {
        <img [src]="optionSelected[optionImgKey()]" alt="" />
      }

      <accredible-icon
        class="select-input-icon"
        [icon]="'chevron-down'"
        [@rotateAnimation]="isOpen ? 'rotated' : 'initial'">
      </accredible-icon>
    </div>
  </div>

  @if (!noError()) {
    <div class="feedback-message">
      @if (formControlRef()?.touched) {
        <ng-content select="accredible-input-feedback" />
      }
    </div>
  }

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayPanelClass]="'accredible-select-input-overlay'"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayOffsetY]="5"
    [cdkConnectedOverlayWidth]="menuWidth"
    [cdkConnectedOverlayOpen]="isOpen"
    (backdropClick)="isOpen = false">
    <accredible-list
      [id]="uid + '-listbox'"
      role="listbox"
      [attr.data-cy]="dataCy() + '-list-items'">
      @for (
        option of optionsWithDynamicLabel() ? optionsWithDynamicLabel() : options();
        track option;
        let i = $index
      ) {
        <accredible-list-item
          role="option"
          [id]="uid + '-' + i"
          [class.disabled]="option.disabled"
          [class.is-focused]="i === focusedOptionIndex"
          [accredibleTooltip]="option[optionTooltipKey()]"
          [attr.aria-selected]="option.name === optionSelected?.name"
          (click)="onSelectOption(option)"
          (selected)="onSelectOption(option)">
          <div
            class="option"
            [attr.data-cy]="
              'option-' + (option.name | syncOrAsync)?.split(' ').join('-').toLowerCase()
            "
            [class.disabled]="option.disabled"
            [class.selected]="option.name === optionSelected?.name"
            [class.hasImg]="option[optionImgKey()]">
            @if (option[optionIconKey()]) {
              <accredible-icon [icon]="option[optionIconKey()]" />
            }

            {{ option.name | syncOrAsync }}

            @if (option[optionImgKey()]) {
              <img [src]="option[optionImgKey()]" alt="" />
            }
          </div>
        </accredible-list-item>
      }
    </accredible-list>
  </ng-template>
</ng-container>
